import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import withTranslations from '../../../utils/HighOrderComponent';
import NavRight from './NavRight';

const NavBar = (props) => {
  const { headerBackColor, headerFixedLayout } = useSelector(
    (state) => state.navigationReducer
  );
  const { gt, t } = props || {};

  let headerClass = ['pcoded-header', 'navbar-expand-lg', headerBackColor];
  if (headerFixedLayout) {
    headerClass = [...headerClass, 'headerpos-fixed'];
  }

  return (
    <Fragment>
      <header className={headerClass.join(' ')}>
        <NavRight gt={gt} t={t} />
      </header>
    </Fragment>
  );
};

export default withTranslations(NavBar, 'menu_items');
